import React, { useEffect, useState } from "react";
import { ArrowRight, Leaf } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { Button } from "../../components/ui/button";

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section
      className="hero-section"
      style={{
        background:
          "radial-gradient(at 53% 78%, hsla(60,100%,50%,0.3) 0px, transparent 50%), radial-gradient(at 71% 91%, hsla(108,100%,50%,0.3) 0px, transparent 50%), radial-gradient(at 31% 91%, hsla(30,100%,50%,0.17) 0px, transparent 50%)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        textAlign: "center",
        padding: "7rem 1.5rem 3rem",
      }}
    >
      <div
        className="hero-content"
        style={{ maxWidth: "900px", margin: "0 auto" }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            background: "rgba(148, 242, 127, 0.1)",
            padding: "0.5rem 1rem",
            borderRadius: "9999px",
            marginBottom: "2rem",
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "rgb(13, 121, 22)",
          }}
        >
          <Leaf size={16} />
          <span>Sustainable Recycling Solutions</span>
        </div>

        <h1
          className="hero-title"
          style={{
            fontWeight: 700,
            fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
            lineHeight: 1,
            letterSpacing: "-0.02em",
            color: "rgb(0, 55, 32)",
            marginBottom: "1.5rem",
          }}
        >
          {t.hero.title}
        </h1>

        <p
          className="hero-subtitle"
          style={{
            fontSize: "clamp(1.25rem, 2.5vw, 1.25rem)",
            lineHeight: 1.5,
            color: "rgb(131, 146, 140)",
            marginBottom: "2rem",
            maxWidth: "700px",
            margin: "0 auto 2rem",
          }}
        >
          {t.hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            className="btn-primary"
            style={{
              background: "linear-gradient(to bottom right, #8FEC78, #81DD67)",
              color: "white",
              border: "none",
              borderRadius: "9999px",
              padding: "14px 32px",
              fontWeight: 600,
              fontSize: "1rem",
              minHeight: "48px",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            {t.hero.ctaPrimary}
            <ArrowRight size={20} />
          </Button>
          <Button
            variant="outline"
            className="btn-secondary"
            style={{
              background: "transparent",
              color: "rgb(0, 55, 32)",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "9999px",
              padding: "14px 32px",
              fontWeight: 500,
              fontSize: "1rem",
              minHeight: "48px",
            }}
          >
            {t.hero.ctaSecondary}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
